import React from 'react'
import Orange1 from './img/blob-orange.png'

const BlobOrange = () => <img src={Orange1} className="Blob___orange" alt="Flume Health" />

export {BlobOrange}
